// Keep workspace visibility aligned with the route guards. Data access is
// enforced separately by Firestore/Storage rules and server authorization.
export const PORTAL_ROLES = Object.freeze(['admin', 'staff', 'manager', 'office'])
export const FINANCE_ROLES = Object.freeze(['admin', 'manager', 'accountant'])
export const OPERATIONS_ROLES = Object.freeze(['admin', 'manager', 'office'])

// Personal attendance is a separate capability for an administrator who also
// works shifts. The server still requires the account's active employee binding.
export function hasPersonalTimesheet(role, attendanceEmployee = false) {
  return role === 'staff'
    || (['admin', 'manager', 'office'].includes(role) && attendanceEmployee === true)
}

export function hasWorkspaceAccess(role, workspace) {
  if (workspace === 'artgold_admin') return FINANCE_ROLES.includes(role)
  if (workspace === 'jobs') return PORTAL_ROLES.includes(role)
  if (workspace === 'exchange_desk' || workspace === 'product_listing') return OPERATIONS_ROLES.includes(role)
  return false
}
